/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HeartbeatRequest,
  ProblemDetails,
  StaffOnlinePerson,
} from '../models/index';
import {
    HeartbeatRequestFromJSON,
    HeartbeatRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    StaffOnlinePersonFromJSON,
    StaffOnlinePersonToJSON,
} from '../models/index';

export interface ApiStaffOnlineGetRequest {
    xTenantID?: number;
}

export interface ApiStaffOnlinePutRequest {
    xTenantID?: number;
    heartbeatRequest?: HeartbeatRequest;
}

/**
 * 
 */
export class StaffOnlineApi extends runtime.BaseAPI {

    /**
     * List employees who have the dashboard open
     */
    async apiStaffOnlineGetRaw(requestParameters: ApiStaffOnlineGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StaffOnlinePerson>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/staff-online`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StaffOnlinePersonFromJSON));
    }

    /**
     * List employees who have the dashboard open
     */
    async apiStaffOnlineGet(requestParameters: ApiStaffOnlineGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StaffOnlinePerson>> {
        const response = await this.apiStaffOnlineGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Record that this person has the dashboard open
     */
    async apiStaffOnlinePutRaw(requestParameters: ApiStaffOnlinePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/staff-online`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HeartbeatRequestToJSON(requestParameters['heartbeatRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Record that this person has the dashboard open
     */
    async apiStaffOnlinePut(requestParameters: ApiStaffOnlinePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiStaffOnlinePutRaw(requestParameters, initOverrides);
    }

}
